import { Model, RailsFormat } from "./model"
import * as moment from "moment"
import { Contact } from "./contact"
import { Absence } from "./absence"
import { MatrixClass } from "./matrix-class";

export class ModifiedClass extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public contactId?: number,
    public matrixClassId?: number,
    public absenceId?: number,
    public date: Date = null,

    public contact: Contact = null,
    public matrixClass: MatrixClass = null,
    public absence: Absence = null,
  ) {
    super()
  }

  public static clone(obj: any) {
    const modifiedClass: ModifiedClass = new this()

    if (obj.id) { modifiedClass.id = obj.id }
    if (obj.contactId) { modifiedClass.contactId = obj.contactId }
    if (obj.matrixClassId) { modifiedClass.matrixClassId = obj.matrixClassId }
    if (obj.absenceId) { modifiedClass.absenceId = obj.absenceId }
    if (obj.date) { modifiedClass.date = new Date(obj.date) }

    if (obj.contact) { modifiedClass.contact = Contact.clone(obj.contact) }
    if (obj.matrixClass) { modifiedClass.matrixClass = MatrixClass.clone(obj.matrixClass) }
    if (obj.absence) { modifiedClass.absence = Absence.clone(obj.absence) }

    return modifiedClass
  }

  serializeForRails() {
    const response: any = Object.assign({}, this) 

    if (this.id === 0) { response.id = null }
    if (this.date) {
      response.date = moment(this.date).format("YYYY-MM-DD")
    }

    return response
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/modified-class.ts